// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// Front-end site-id fallbacks. The alarm seed data that used to live here was
// removed — alarms are served by services/alarmsService.ts (backend-backed,
// currently stubbed). Only the display-label / default-site fallbacks below
// remain, since they are config, not alarm records.

// Display-label fallback for alarm site ids. Real site labels come from OMS /
// the /me response (see useAuth().sites and useOperatorSite); this map only
// backs alarm cards for the two real site ids the app references.
export const SITE_LABELS: Record<string, string> = {
  'GA-10': 'GA-10 · Marietta',
  'simple-dc-001': 'HQ · San Francisco',
};

/**
 * Default operator site id, used only as a fallback when the authenticated
 * user has no OMS site assigned. Prefer useActiveSite(), which resolves the
 * site from useAuth().sites (OMS + /me) and gates switching by persona.
 */
export const OPERATOR_SITE_ID = 'GA-10';
